/* ======================================================
   FREE GIFT ENGINE — FINAL STABLE VERSION
====================================================== */

let cartData = {
  total_price: 0,
  items: []
};

let giftActionLock = false;
let selectedVariantId = null;
let previousSavingValue = null;


let milestoneLastProgress = null;



/* -----------------------------------
   INTERCEPT CART API CALLS
----------------------------------- */

const originalFetch = window.fetch;

window.fetch = async function (...args) {
  const response = await originalFetch.apply(this, args);

  const url = args[0];

  // Only react to cart-changing endpoints
  if (
    typeof url === 'string' &&
    (url.includes('/cart/add') ||
     url.includes('/cart/change') ||
     url.includes('/cart/update'))
  ) {
    // Prevent recursive triggering
    if (!giftActionLock) {
      setTimeout(syncCartData, 250);
    }
  }

  return response;
};

/* -----------------------------------
   SYNC FULL CART DATA
----------------------------------- */

function syncCartData() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      cartData.total_price = cart.total_price;
      cartData.items = cart.items;

      runGiftEngine();

    });
    
}

/* -----------------------------------
   MAIN GIFT LOGIC
----------------------------------- */

function runGiftEngine() {
  if (!window.freeGiftSettings?.enabled) return;

  const {
    threshold1,
    threshold2,
    gift1VariantId,
    gift2VariantId
  } = window.freeGiftSettings;

  const total = cartData.total_price;

  const hasGift1 = cartData.items.some(
    item => item.variant_id == gift1VariantId
  );

  const hasGift2 = cartData.items.some(
    item => item.variant_id == gift2VariantId
  );

  // ---------- GIFT 1 ----------
  if (gift1VariantId) {
    if (total >= threshold1 && !hasGift1) {
      addGift(gift1VariantId);
      return;
    }

    if (total < threshold1 && hasGift1) {
      
      removeGift(gift1VariantId);
      return;
    }
  }

  // ---------- GIFT 2 ----------
  if (gift2VariantId) {
    if (total >= threshold2 && !hasGift2) {
      addGift(gift2VariantId);
      return;
    }

    if (total < threshold2 && hasGift2) {
      removeGift(gift2VariantId);
      return;
    }
  }
}

/* -----------------------------------
   ADD GIFT
----------------------------------- */

async function addGift(variantId) {
  try {

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _free_gift: true },
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    // ✅ Let Shopify handle section rendering
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && data.sections) {
      cartDrawer.renderContents(data);
    }

    // Sync cartData after render
    await syncCartData();


    const giftRow = document.querySelector(`.cart-item[data-variant-id="${variantId}"]`);
    if (giftRow) {
      giftRow.classList.add("cart-item-highlight");
    }

  } catch (error) {
    console.error("❌ Free gift add error:", error);
  }
}



/* -----------------------------------
   REMOVE GIFT
----------------------------------- */

async function removeGift(variantId) {
  const giftRow = document.querySelector(`.cart-item[data-variant-id="${variantId}"]`);
  if (giftRow) {
        giftRow.classList.add("cart-item-highlight-red");
      }
  try {

    // 1️⃣ Get latest cart
    const cartRes = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await cartRes.json();

    // 2️⃣ Find line number
    const itemIndex = cart.items.findIndex(
      item => item.variant_id === variantId && item.properties?._free_gift
    );

    if (itemIndex === -1) {
      console.log("❌ Gift not found in cart");
      return;
    }

    const lineNumber = String(itemIndex + 1); // Shopify line is 1-based

    // 3️⃣ Call change API
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        line: lineNumber,
        quantity: 0,
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    // 4️⃣ Re-render drawer properly
    const drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections) {
      drawer.renderContents(data);
    }

    // 5️⃣ Sync cartData again
    await syncCartData();

  } catch (error) {
    console.error("❌ Remove gift error:", error);
  }
}





/* -----------------------------------
   INITIAL SYNC ON PAGE LOAD
----------------------------------- */

document.addEventListener('DOMContentLoaded', () => {
  syncCartData();
});




class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
    

    document.body.classList.add('overflow-hidden');

    requestAnimationFrame(() => {
      initializeMilestoneBar();
      restartCouponBadgeAnimation();
    });
    // initSavingsScrollBehavior();

    

  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const currentEl = document.querySelector('.savings-counter');
    if (currentEl) {
      previousSavingValue = parseInt(currentEl.dataset.saving, 10);
    }



    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      requestAnimationFrame(() => {

        const drawer = this.querySelector('#CartDrawer');
        if (!drawer) return;

        triggerMilestoneAnimationAfterRender();


        /* ---------------------------
          SAVINGS COUNTER (UNCHANGED)
        ---------------------------- */

        const el = document.querySelector('.savings-counter');
        if (!el) return;

        const target = parseInt(el.dataset.saving, 10);

        if (previousSavingValue !== null) {
          //el.textContent = formatMoney(previousSavingValue);
          // animateSavingsCounter(target);
        } else {
          previousSavingValue = target;
        }

      });



    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {

  updateQuantity(line, quantity, name) {

    const currentEl = document.querySelector('.savings-counter');
    if (currentEl) {
      previousSavingValue = parseInt(currentEl.dataset.saving, 10);
    }

    super.updateQuantity(line, quantity, name);
    // triggerSavingsAnimationAfterRender();
    triggerMilestoneAnimationAfterRender();

  }




  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
  onCartUpdate() {
    super.onCartUpdate();

    setTimeout(() => {
      // animateSavingsCounter();
    }, 300);
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




document.addEventListener('click', function (event) {

  const modal = document.getElementById('UpsellVariantModal');
  if (!modal) return;

  const variantList = modal.querySelector('.upsell-variant-list');
  const confirmBtn = modal.querySelector('.upsell-confirm-btn');

  /* ----------------------------
     OPEN VARIANT MODAL
  ----------------------------- */

  const openBtn = event.target.closest('.upsell-add-btn');

  if (openBtn) {
    event.preventDefault();

    const productWrapper = openBtn.closest('.cart-upsell-item');
    const productData = JSON.parse(productWrapper.dataset.productJson);
    const variantOverrideId = productWrapper.dataset.variantOverride;

    variantList.innerHTML = '';
    selectedVariantId = null;
    confirmBtn.disabled = true;

    const availableVariants = productData.variants.filter(v => v.available);

    // If only 1 available → add directly
    if (availableVariants.length === 1) {
      addVariantToCart(availableVariants[0].id);
      return;
    }

    availableVariants.forEach(variant => {

      const row = document.createElement('div');
      row.className = 'upsell-variant-row';
      row.dataset.id = variant.id;

      const img = document.createElement('img');
      img.src = variant.featured_image
        ? variant.featured_image.src
        : productData.featured_image;

      const info = document.createElement('div');
      info.className = 'upsell-variant-info';

      const priceWrapper = document.createElement('div');
      priceWrapper.className = 'upsell-variant-price';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWrapper.innerHTML = `
          <span class="final-price">
            ₹${Math.floor(variant.price / 100)}
          </span>
          <span class="original-price">
            ₹${Math.floor(variant.compare_at_price / 100)}
          </span>
        `;
      } else {
        priceWrapper.innerHTML = `
          <span class="final-price">
            ₹${Math.floor(variant.price / 100)}
          </span>
        `;
      }

      info.innerHTML = `
        <div class="variant-title">${variant.title}</div>
      `;

      row.appendChild(img);
      row.appendChild(info);
      row.appendChild(priceWrapper);

      variantList.appendChild(row);

      // 🔥 PRESELECT OVERRIDE VARIANT
      if (variantOverrideId && variant.id.toString() === variantOverrideId) {
        row.classList.add('active');
        selectedVariantId = variant.id;
        confirmBtn.disabled = false;
      }

    });

    document.activeElement.blur();

    modal.hidden = false;
    document.querySelector('.drawer__inner').classList.add('modal-open');
    return;
  }


  /* ----------------------------
     SELECT VARIANT
  ----------------------------- */

  const variantRow = event.target.closest('.upsell-variant-row');

  if (variantRow) {

    modal.querySelectorAll('.upsell-variant-row')
      .forEach(row => row.classList.remove('active'));

    variantRow.classList.add('active');

    selectedVariantId = variantRow.dataset.id;
    confirmBtn.disabled = false;

    return;
  }

  /* ----------------------------
     CONFIRM SELECTION
  ----------------------------- */

  if (event.target.closest('.upsell-confirm-btn')) {

    if (!selectedVariantId) return;

    addVariantToCart(selectedVariantId);

    closeVariantModal();


    return;
  }

  /* ----------------------------
     CLOSE MODAL
  ----------------------------- */

  if (
    event.target.closest('.upsell-modal-close') ||
    event.target.closest('.upsell-modal-overlay')
  ) {
    closeVariantModal();
  }


});


/* ----------------------------------
   ADD VARIANT TO CART (SENSES SAFE)
----------------------------------- */

function addVariantToCart(variantId) {

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  showCartLoader(); // if enabled

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: cartDrawer.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then(parsedState => {

    cartDrawer.renderContents(parsedState);

    // Wait for DOM update
    setTimeout(() => {
      highlightAndScrollToRow(variantId);
    }, 150);

  })
  .then(() => {
    hideCartLoader();
  })
  .catch(error => {
    console.error('Variant add error:', error);
    hideCartLoader();
  });
}



function closeVariantModal() {
  const modal = document.getElementById('UpsellVariantModal');
  const confirmBtn = modal.querySelector('.upsell-confirm-btn');

  modal.hidden = true;
  confirmBtn.disabled = true;
  selectedVariantId = null;

  const drawerInner = document.querySelector('.drawer__inner');
  if (drawerInner) {
    drawerInner.classList.remove('modal-open');
  }
}


function showCartLoader() {

  const isEnabled = document.documentElement.dataset.enableCartLoader === "true";
  if (!isEnabled) return;

  const loader = document.getElementById('CartGlobalLoader');
  const drawerInner = document.querySelector('.drawer__inner');

  if (!loader || !drawerInner) return;

  loader.hidden = false;
  drawerInner.classList.add('loading-state');
}


function hideCartLoader() {

  const isEnabled = document.documentElement.dataset.enableCartLoader === "true";
  if (!isEnabled) return;

  const loader = document.getElementById('CartGlobalLoader');
  const drawerInner = document.querySelector('.drawer__inner');

  if (!loader || !drawerInner) return;

  loader.hidden = true;
  drawerInner.classList.remove('loading-state');
}

function highlightAndScrollToRow(variantId) {

  const cartRows = document.querySelectorAll('#CartDrawer .cart-item');

  cartRows.forEach(row => {

    const qtyInput = row.querySelector('[data-quantity-variant-id]');
    if (!qtyInput) return;

    const rowVariantId = qtyInput.getAttribute('data-quantity-variant-id');

    if (rowVariantId == variantId) {
      row.classList.add('cart-item-highlight');
    }

  });
}


function animateSavingsCounter(target) {

  // initSavingsScrollBehavior();

  const el = document.querySelector('.savings-counter');
  if (!el) return;

  const startValue = previousSavingValue;
  const change = target - startValue;

  if (change === 0) return;

  const duration = 700;
  const startTime = performance.now();

  function update(currentTime) {
    const progress = Math.min((currentTime - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    const currentValue = Math.floor(startValue + change * eased);

    el.textContent = formatMoney(currentValue);

    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      previousSavingValue = target;
    }
  }

  requestAnimationFrame(update);
}


function triggerSavingsAnimationAfterRender() {
  const observer = new MutationObserver(() => {
    const el = document.querySelector('.savings-counter');
    if (!el) return;

    const target = parseInt(el.dataset.saving, 10);

    observer.disconnect();

    // If first load
    if (previousSavingValue === null) {
      previousSavingValue = target;
      return;
    }

    // Immediately revert to previous value
    //el.textContent = formatMoney(previousSavingValue);

    //animateSavingsCounter(target);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}






function formatMoney(cents) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: Shopify.currency.active || 'INR',
    maximumFractionDigits: 0
  }).format(cents / 100);
}


let lastRenderedProgress = null;

let celebratedMilestones = new Set();

function updateMilestoneBadges(progress) {

  const badges = document.querySelectorAll('.milestone-badge');

  badges.forEach(badge => {

    const percent = parseFloat(badge.dataset.percent);
    if (isNaN(percent)) return;

    const thresholdKey = percent.toString();
    const isActive = progress >= percent;

    if (isActive) {

      // Always apply active visual state
      badge.classList.add("milestone-active");

      // 🎉 Only celebrate once per threshold crossing
      if (!celebratedMilestones.has(thresholdKey)) {

        celebratedMilestones.add(thresholdKey);

        // Micro vibration
        badge.style.animation = "milestoneVibrate 0.3s ease";
        setTimeout(() => {
          badge.style.animation = "";
        }, 300);

        // Shine celebration (separate from active state)
        badge.classList.add("milestone-celebrate");

        // Remove celebrate class after animation finishes
        setTimeout(() => {
          badge.classList.remove("milestone-celebrate");
        }, 3500); // 1s delay + 2.2s shine + buffer
      }

    } else {

      // Remove visual active state
      badge.classList.remove("milestone-active");

      // Allow celebration again if cart drops below threshold
      celebratedMilestones.delete(thresholdKey);
    }

  });
}





function triggerMilestoneAnimationAfterRender() {
  const observer = new MutationObserver(() => {

    const fillEl = document.querySelector('.milestone-fill');
    if (!fillEl) return;

    const progress = parseFloat(fillEl.dataset.progress) || 0;
    const newScale = progress / 100;

    observer.disconnect();

    // First ever load
    if (milestoneLastProgress === null) {
      milestoneLastProgress = newScale;
      fillEl.style.transform = `scaleX(${newScale})`;
      
      return;
    }

    if (Math.abs(milestoneLastProgress - newScale) < 0.001) 
      {
        // 🔥 Even if scale hasn't changed, ensure transform is correct
        fillEl.style.transition = "none";
        fillEl.style.transform = `scaleX(${newScale})`;
        updateMilestoneBadges(progress);
        return;
      }

    // Force previous scale
    fillEl.style.transition = "none";
    fillEl.style.transform = `scaleX(${milestoneLastProgress})`;

    // Separate paint cycle
    requestAnimationFrame(() => {
      fillEl.style.transition =
        "transform 1.8s cubic-bezier(0.19, 1, 0.22, 1)";
      fillEl.style.transform = `scaleX(${newScale})`;
    });

    milestoneLastProgress = newScale;
    updateMilestoneBadges(progress);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function initializeMilestoneBar() {

  const fillEl = document.querySelector('.milestone-fill');
  if (!fillEl) return;

  const progress = parseFloat(fillEl.dataset.progress) || 0;
  const scale = progress / 100;

  // First ever open → animate from 0
  if (milestoneLastProgress === null) {

    fillEl.style.transition = "none";
    fillEl.style.transform = "scaleX(0)";

    requestAnimationFrame(() => {
      fillEl.style.transition =
        "transform 1.8s cubic-bezier(0.19, 1, 0.22, 1)";
      fillEl.style.transform = `scaleX(${scale})`;
    });

    milestoneLastProgress = scale;
    updateMilestoneBadges(progress);
    return;
  }

  // Subsequent opens → just set instantly
  fillEl.style.transform = `scaleX(${scale})`;
}



// function updateMilestoneBar() {

//   const fillEl = document.querySelector('.milestone-fill');
//   if (!fillEl) return;

//   const newProgress = parseFloat(fillEl.style.width);

//   if (isNaN(newProgress)) return;

//   // First render — store value, no animation
//   if (lastRenderedProgress === null) {
//     lastRenderedProgress = newProgress;
//     return;
//   }

//   // If same, do nothing
//   if (Math.abs(lastRenderedProgress - newProgress) < 0.1) return;

//   // Animate from old to new
//   fillEl.style.transition = "none";
//   fillEl.style.width = lastRenderedProgress + "%";

//   fillEl.offsetHeight; // force reflow

//   fillEl.style.transition = "width 0.8s cubic-bezier(0.22, 1, 0.36, 1)";
//   fillEl.style.width = newProgress + "%";

//   lastRenderedProgress = newProgress;
// }

// function animateMilestoneFill(fillEl) {


//   const newProgress = parseFloat(fillEl.style.width);

//   if (isNaN(newProgress)) return;

//   if (lastRenderedProgress === null) {
//     lastRenderedProgress = newProgress;
//     return;
//   }

//   if (Math.abs(lastRenderedProgress - newProgress) < 0.1) return;

//   fillEl.style.transition = "none";
//   fillEl.style.width = lastRenderedProgress + "%";

//   fillEl.offsetHeight;

//   fillEl.style.transition = "width 0.8s cubic-bezier(0.22, 1, 0.36, 1)";
//   fillEl.style.width = newProgress + "%";

//   lastRenderedProgress = newProgress;
// }

function restartCouponBadgeAnimation() {

  const badge = document.querySelector('.inline-coupon-badge');
  if (!badge) return;

  // Remove animation classes by forcing reflow
  badge.style.animation = 'none';
  badge.offsetHeight; // force reflow
  badge.style.animation = '';

  // Restart icon + text animations if needed
  const icon = badge.querySelector('.coupon-icon');
  const text = badge.querySelector('.coupon-text');

  if (icon) {
    icon.style.animation = 'none';
    icon.offsetHeight;
    icon.style.animation = '';
  }

  if (text) {
    text.style.animation = 'none';
    text.offsetHeight;
    text.style.animation = '';
  }
}



function initSavingsScrollBehavior() {
  
  requestAnimationFrame(() => {

    const scrollContainer = document.querySelector('cart-drawer-items');
    const savingRow = document.querySelector('.footer-saving-row');
    const milestoneTrack = document.querySelector('.milestone-track');

    if (!scrollContainer) {
      return;
    }

    if (!savingRow) {
      return;
    }

    function handleScroll() {
      const scrollTop = scrollContainer.scrollTop;

      const shouldHide = scrollTop > 10;

      if (shouldHide) {
        savingRow?.classList.add('is-hidden');
         milestoneTrack?.classList.add('is-hidden');
      } else {
        savingRow?.classList.remove('is-hidden');
         milestoneTrack?.classList.remove('is-hidden');
      }
    }


    scrollContainer.addEventListener('scroll', handleScroll);


    handleScroll(); // run once

  });

}